import React, { useEffect, useState, useContext } from "react";
import { FaSearch, FaChevronLeft, FaChevronRight, FaUserPlus } from "react-icons/fa";
import ProspectoForm from "./ProspectoForm";
import ProspectosTable from "./ProspectosTable";
import Modal from "../Modal";
import { AuthContext } from "../../context/AuthContext";

export default function Prospectos() {
  const { user, token } = useContext(AuthContext);

  const [prospectos, setProspectos] = useState([]);
  const [busqueda, setBusqueda] = useState("");
  const [pagina, setPagina] = useState(1);
  const [mostrarFormulario, setMostrarFormulario] = useState(false);
  const registrosPorPagina = 7;

  const cargarProspectos = async () => {
    try {
      const res = await fetch("/api/prospectos", {
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      });
      const data = await res.json();
      setProspectos(data.data || data);
    } catch (error) {
      console.error("Error cargando prospectos:", error);
    }
  };

  useEffect(() => {
    cargarProspectos();
  }, []);

  const prospectosFiltrados = prospectos.filter(p =>
    p.nombre?.toLowerCase().includes(busqueda.toLowerCase()) ||
    p.telefono?.toLowerCase().includes(busqueda.toLowerCase())
  );

  const totalPaginas = Math.ceil(prospectosFiltrados.length / registrosPorPagina);
  const inicio = (pagina - 1) * registrosPorPagina;
  const fin = inicio + registrosPorPagina;
  const prospectosPagina = prospectosFiltrados.slice(inicio, fin);
  const inicioRango = prospectosFiltrados.length === 0 ? 0 : inicio + 1;
  const finRango = Math.min(fin, prospectosFiltrados.length);

  return (
    <div className="p-6 bg-slate-50">

      {/* HEADER */}
      <div className="flex items-start justify-between gap-4 mb-4">
        <div>
          <h1 className="text-xl font-bold text-slate-800">
            Prospectos {user ? `- ${user.nombre}` : ""}
          </h1>
          <p className="text-xs text-slate-500 mt-0.5">
            Registro y seguimiento de prospectos de evangelismo.
          </p>
        </div>
        <button
          onClick={() => setMostrarFormulario(true)}
          className="shrink-0 flex items-center gap-2 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-medium px-4 py-2 rounded-lg transition"
        >
          <FaUserPlus className="text-xs" /> Nuevo prospecto
        </button>
      </div>

      {/* BUSCADOR */}
      <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-4 mb-4">
        <div className="relative">
          <FaSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-300 text-sm" />
          <input
            type="text"
            placeholder="Buscar por nombre o teléfono..."
            className="w-full pl-9 pr-3 py-2 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-200 focus:border-indigo-400"
            value={busqueda}
            onChange={(e) => {
              setBusqueda(e.target.value);
              setPagina(1);
            }}
          />
        </div>
      </div>

      <ProspectosTable
        prospectos={prospectosPagina}
        cargarProspectos={cargarProspectos}
      />

      {/* PAGINACIÓN */}
      <div className="flex justify-between items-center mt-4">
        <span className="text-sm text-slate-500">
          {prospectosFiltrados.length === 0
            ? "Sin resultados"
            : `Mostrando ${inicioRango} a ${finRango} de ${prospectosFiltrados.length} resultados`}
        </span>

        {totalPaginas > 1 && (
          <div className="flex items-center gap-2">
            <button
              disabled={pagina === 1}
              onClick={() => setPagina(pagina - 1)}
              className="w-8 h-8 flex items-center justify-center rounded-md border border-slate-200 text-slate-500 disabled:opacity-40 hover:bg-slate-50 transition"
            >
              <FaChevronLeft className="text-xs" />
            </button>

            {Array.from({ length: totalPaginas }, (_, i) => (
              <button
                key={i}
                onClick={() => setPagina(i + 1)}
                className={`w-8 h-8 flex items-center justify-center rounded-md text-sm font-semibold transition ${
                  pagina === i + 1
                    ? "bg-indigo-600 text-white"
                    : "border border-slate-200 text-slate-500 hover:bg-slate-50"
                }`}
              >
                {i + 1}
              </button>
            ))}

            <button
              disabled={pagina === totalPaginas}
              onClick={() => setPagina(pagina + 1)}
              className="w-8 h-8 flex items-center justify-center rounded-md border border-slate-200 text-slate-500 disabled:opacity-40 hover:bg-slate-50 transition"
            >
              <FaChevronRight className="text-xs" />
            </button>
          </div>
        )}
      </div>

      {/* MODAL NUEVO PROSPECTO */}
      <Modal
        open={mostrarFormulario}
        onClose={() => setMostrarFormulario(false)}
        title="Nuevo prospecto"
        maxWidth="max-w-2xl"
      >
        <ProspectoForm
          cargarProspectos={cargarProspectos}
          onGuardado={() => setMostrarFormulario(false)}
        />
      </Modal>
    </div>
  );
}
